import type { SeededRandom } from "../core/SeededRandom";
import { TileType, pointKey, type LevelData, type Point, type PropSpawn } from "./types";

export function placeDungeonProps(level: LevelData, random: SeededRandom): PropSpawn[] {
  const props: PropSpawn[] = [];
  const reserved = [
    level.playerStart,
    level.exit,
    ...level.pickups.map((p) => p.cell),
    ...level.enemies.map((e) => e.cell),
    ...level.doors.flatMap((d) => d.cells),
  ];
  const protectedCells = new Set<string>();
  for (const point of reserved) {
    for (let y = -1; y <= 1; y++)
      for (let x = -1; x <= 1; x++) {
        protectedCells.add(pointKey({ x: point.x + x, y: point.y + y }));
      }
  }
  for (const room of level.rooms) {
    const candidates: Point[] = [];
    for (let y = room.y + 2; y < room.y + room.height - 2; y++) {
      for (let x = room.x + 2; x < room.x + room.width - 2; x++) {
        if (Math.abs(x - room.center.x) <= 2 || Math.abs(y - room.center.y) <= 2) continue;
        if (level.grid.get({ x, y }) === TileType.Floor && !protectedCells.has(pointKey({ x, y })))
          candidates.push({ x, y });
      }
    }
    let count = 0;
    for (const cell of random.shuffle(candidates)) {
      if (count >= 4 || protectedCells.has(pointKey(cell))) continue;
      // An intact ring around the prop preserves local connectivity without a flood fill per prop.
      let ringOpen = true;
      for (let y = -1; y <= 1; y++)
        for (let x = -1; x <= 1; x++) {
          if (!level.grid.isWalkable({ x: cell.x + x, y: cell.y + y }, false)) ringOpen = false;
        }
      if (!ringOpen) continue;
      level.grid.set(cell, TileType.Obstacle);
      props.push({
        id: `${room.id}-prop-${count}`,
        kind: count % 3 === 2 ? "pillar" : "crate",
        cell,
      });
      for (let y = -2; y <= 2; y++)
        for (let x = -2; x <= 2; x++)
          protectedCells.add(pointKey({ x: cell.x + x, y: cell.y + y }));
      count++;
    }
  }
  return props;
}
